import React, { useState } from "react";
import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { useParams } from "react-router-dom";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";
import { StatusCell } from "@/components/status/cell";
import { DateCell } from "@/components/date/cell";
import { EmployeeUserCell } from "components/cell/employee/cell";
import { getUserFields, getdirectusUserFields } from "components/user/config";
import SurveyCardSection from "./components/card-section";
import PerformanceDetailsSidebar from "@/modules/performance/overview/components/performance-details-sidebar";

export default function Surveys() {

    const { jobId } = useParams();
    const [selectedCard, setSelectedCard] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleCardClick = (cardData) => {
        setSelectedCard(cardData);
        setIsSidebarOpen(true);
    };

    const handleCloseSidebar = () => {
        setIsSidebarOpen(false);
        setSelectedCard(null);
    };

    const columns = [
        {
            id: "title",
            header: "Title",
            accessorKey: "title",
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
        {
            id: "date_created",
            header: "Created on",
            accessorKey: "date_created",
            cell: DateCell,
        },
        {
            id: "user_created",
            header: "Created by",
            accessorKey: "user_created",
            cell: EmployeeUserCell,
        },
        {
            id: "submitted_on",
            header: "Submitted On",
            accessorKey: "submitted_on",
            cell: DateCell,
        },
        {
            id: "submitted_by",
            header: "Submitted by",
            accessorKey: "submitted_by",
            cell: EmployeeUserCell,
        },
    ];

    const fields = [
        "id",
        "status",
        "title",
        "job",
        "date_created",
        "submitted_on",
        getdirectusUserFields("user_created"),
        getdirectusUserFields("submitted_by"),
    ];

    const filters = {
        job: {
            _eq: jobId,
        },
    };

    return (
        <div className="flex-1 w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:AM"}
                    collection="surveys"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Survey</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <SurveyCardSection onClick={handleCardClick} />
            <List
                title="Surveys"
                endPoint="surveys"
                storageKey={`surveys-${jobId}`}
                showSearch={false}
                filters={filters}
                columns={columns}
                meta={{ fields }}
                href={(item) => `/work/jobs/${jobId}/surveys/${item.id}`}
            />
            <PerformanceDetailsSidebar
                isOpen={isSidebarOpen}
                onClose={handleCloseSidebar}
                cardData={selectedCard}
            />
        </div>
    );
}
